<template>
  <div class="project">
      <div class="project_pop">
          <img style="max-width: 100%;max-height: 100%;" :src="Main.imgserve +'/PROJECT/ProjectPOP.png'" alt="">
      </div>
    <div class="swiper_div">
      <Swiper class="swiper" navigation :options="swiperOptionPro">
        <SwiperSlide v-for="(value, indexs) in swiperlist" :key="indexs">
          <template>
            <div class="content">
              <div
                style="width: 100%; height: 100%;display: flex;
    justify-content: center;
    align-items: center;"
                v-if="value.type == 0"
              >
                <img :src="Main.imgserve + value.url" alt="" />
              </div>
            </div>
          </template>
        </SwiperSlide>
        <div class="swiper-pagination" slot="pagination"></div>
      </Swiper>
    </div>
    <div class="left_imgcontent">
      <h2 style="margin-top: 2vh;text-align: end; width: 80%">PROJECT VISION</h2>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import Swiper2, { Navigation, Pagination, Autoplay } from "swiper";
import SwiperCore, { EffectFade } from "swiper";
import "swiper/swiper.less";
import "swiper/components/effect-fade/effect-fade.less";
Swiper2.use([Navigation, Pagination, Autoplay]);
SwiperCore.use([EffectFade]);

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperlist: [
        { name: "001", url: "/PROJECT/ENT-P01.png", type: 0 },
        { name: "003", url: "/PROJECT/ENT-P02.png", type: 0 },
        { name: "002", url: "/PROJECT/ENT-P03.png", type: 0 },
        { name: "004", url: "/PROJECT/ENT-P04.png", type: 0 },
        { name: "005", url: "/PROJECT/ENT-P05.png", type: 0 },
        { name: "006", url: "/PROJECT/ENT-P06.png", type: 0 },

      ],
      swiperOptionPro: {
        effect: "fade",
        // coverflowEffect: {
        // rotate: 50,
        // stretch: 0,
        // depth: 100,
        // modifier: 1,
        // slideShadows: true,
        // },
        autoplay: true, // 自动播放
        loop: true, // 循环
        initialSlide: 0, //初始值
        slidesPerView: 1,
        grabCursor: true,
        centeredSlides: true,
        clickable: true,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          //   bulletElement : 'li',
          clickable: true,
          bulletActiveClass:'my-bullet-active'
          // dynamicBullets: true,
          // dynamicMainBullets: 2,
          // progressbarOpposite:true,
          // dynamicBullets:true,
          //   renderBullet: function (index, className){
          //     console.log(className)

          //     return '<h2 class="'+className+'">' + (index + 1) + '</h2>';
          //   }
        },
        navigation: {
          // 无效
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          hideOnClick: true,
        },
       
      },
    };
  },
  methods: {
    onSwiper(swiper) {
      console.log(swiper);
    },
    onSlideChange() {
      console.log("slide change");
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.project {
  width: 100%;
  height: 100%;
  margin: 0;
  background: url('../assets/bga.png') no-repeat;
  background-size: 100% 100%;
  .project_pop{
      position: fixed;
      right: 0px;
      top: 12%;
      z-index: 990;
      max-width: 20%;
      height: 75%;
    //   background-color: #f3f3f3cc;
  }


  .swiper_div {
    margin-left: 1vw;
    width: 78%;
    height: 100%;
    .swiper {
      width: 100%;
      height: 100%;
      .content {
        width: 100%;
        height: 100%;

        // img {
          // max-width: 100%;
          // width: 100%;
        //   height: 100%;
          // max-height: 100%;
        // }
      }
    }
  }

}

.my-bullet-active{
  background: #f5f4f4;
  opacity: 1;
}

</style>